module.exports = __webpack_public_path__ + "img/medico.7c815fbd.png";